// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"61da5a27","354":"880c3ad2","685":"58c6b362","749":"f6a24e43","867":"b8c53be3","960":"b2eaf09e"}[chunkId] + ".chunk.css";
};